(function (window, document, undefined) {

  'use strict';
  // STICKY NAVBAR
  let didScroll;
  let lastScrollTop = 0;
  let delta = 5;
  let navbarHeight = document.querySelector('.navbar').offsetHeight;

  window.addEventListener('scroll', (event) => {
    didScroll = true;
  });


  setInterval(function () { // wait for it... wait for it... wait for it
    if (didScroll) {
      hasScrolled();
      didScroll = false;
    }
  }, 200);

  function hasScrolled() {
    let scrolltop = window.pageYOffset || document.documentElement.scrollTop;
    // Make sure they scroll more than delta
    if (Math.abs(lastScrollTop - scrolltop) <= delta) return;

    // If they scrolled down and are past the navbar, add class .nav-up.
    // This is necessary so you never see what is "behind" the navbar.
    if (scrolltop > lastScrollTop && scrolltop > navbarHeight) {
      // On scroll down we add nav-up
      document.querySelector('.navbar').classList.remove('nav-down');
      document.querySelector('.navbar').classList.add('nav-up');
    } else {
      // On scroll up we add nav-down
      if (scrolltop + window.innerHeight < document.body.clientHeight || document.querySelector('.active').length) {
        document.querySelector('.navbar').classList.remove('nav-up');
        document.querySelector('.navbar').classList.add('nav-down');
      }
    }

    lastScrollTop = scrolltop;
  }
  window.addEventListener('resize', (event) => {
    if (window.innerWidth > 900) {

      document.querySelector('.navbar--menu').classList.remove('activated', 'active');
    }
  });



  let tables = document.querySelectorAll('table');
  for (let i = 0; i < tables.length; i++) {
    tables[i].removeAttribute('width');
  }
  let trs = document.querySelectorAll('tr');
  for (let i = 0; i < trs.length; i++) {
    trs[i].removeAttribute('width');

  }
  let tds = document.querySelectorAll('td');
  for (let i = 0; i < tds.length; i++) {
    tds[i].removeAttribute('width');
  }

  // data-texts
  for (let i = 0; i < tables.length; i++) {
    let headRow = tables[i].querySelectorAll('tr')[0].querySelectorAll('td');
    let rows = tables[i].querySelectorAll('tr');
    for (let x = 0; x < headRow.length; x++) {
      let dataText = headRow[x].innerHTML;
      console.log(dataText)
      for (let y = 0; y < rows.length; y++) {
        rows[y].querySelectorAll('td')[x].setAttribute('data-text', dataText);
      }

    }
  }


  const BURGER = document.querySelector('.burger');
  BURGER.addEventListener('click', () => {

    document.querySelector('.navbar--menu').classList.toggle('toggled');
    document.body.classList.toggle('fixed');
    let openeds = document.querySelectorAll('.opened');
    [].forEach.call(openeds, function (opened) {
      opened.classList.remove('opened');
      })

  });
 document.querySelector('#page').addEventListener('click', () => {
      document.querySelector('.navbar--menu').classList.remove('toggled');
      document.body.classList.remove('fixed');
      let openeds = document.querySelectorAll('.opened');
      [].forEach.call(openeds, function (opened) {
        opened.classList.remove('opened');
      })


    })


  let submenus = document.querySelectorAll('.menu-item-has-children');
  [].forEach.call(submenus, function (submenu) {
    // do whatever
    let opener = submenu.querySelector('a');
    opener.addEventListener('click' , () => {
      opener.parentNode.classList.toggle('opened')
    })
  });
  window.addEventListener('resize', (event) => {
    if (window.innerWidth < 1024) {
      document.querySelector('.navbar--menu').classList.add('mobile');
    } else {
      document.querySelector('.navbar--menu').classList.remove('mobile');
    }
  });
  window.addEventListener('load', (event) => {
    if (window.innerWidth < 1024) {
      document.querySelector('.navbar--menu').classList.add('mobile');
    } else {
      document.querySelector('.navbar--menu').classList.remove('mobile');
    }
  });

  if (navigator.userAgent.match(/Android/i)
    || navigator.userAgent.match(/webOS/i)
    || navigator.userAgent.match(/iPhone/i)
    || navigator.userAgent.match(/iPad/i)
    || navigator.userAgent.match(/iPod/i)
    || navigator.userAgent.match(/BlackBerry/i)
    || navigator.userAgent.match(/Windows Phone/i) ){
      document.body.classList.add('mobile');
    } else {
    document.body.classList.add('desktop');
    }

})(window, document);